import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '1️⃣ ¿Este material sirve para Argentina?',
    a: 'Sí. El contenido está pensado para aspirantes que quieren ingresar a fuerzas dentro de Argentina. El material aborda aspectos comunes del proceso de ingreso como psicotécnicos, entrevistas, simulacros y preparación física.'
  }, {
    q: '2️⃣ ¿Para qué fuerzas puede servir este pack?',
    a: 'El material puede ayudarte a prepararte para procesos de ingreso en distintas instituciones como fuerzas armadas o fuerzas de seguridad. Muchos de los contenidos (psicotécnico, entrevista, preparación física y simulacros) son evaluaciones habituales dentro de estos procesos.'
  }, {
    q: '3️⃣ ¿Cómo recibo el material después de comprar?',
    a: 'Una vez realizada la compra, recibirás acceso inmediato al contenido para poder descargarlo y comenzar tu preparación. Todo el material está organizado para que puedas avanzar paso a paso.'
  }, {
    q: '4️⃣ ¿Necesito experiencia previa para usar este pack?',
    a: 'No. El contenido está pensado tanto para personas que recién comienzan a prepararse como para aspirantes que ya están entrenando para el ingreso.'
  }, {
    q: '5️⃣ ¿El material incluye ejercicios para practicar?',
    a: 'Sí. Dentro del pack encontrarás ejercicios, simulacros y materiales de práctica que te permitirán familiarizarte con el tipo de pruebas que suelen aparecer en el ingreso.'
  }, {
    q: '6️⃣ ¿El pack incluye preparación física?',
    a: 'Sí. Incluye un plan de entrenamiento de 8 semanas pensado para ayudarte a trabajar tu preparación física de forma progresiva.'
  }, {
    q: '7️⃣ ¿También incluye preparación para la entrevista?',
    a: 'Sí. El pack incluye una guía de entrevista con recomendaciones para prepararte mejor para esta etapa del proceso.'
  }, {
    q: '8️⃣ ¿Cuánto tiempo tengo acceso al material?',
    a: 'Una vez que accedés al pack, el material es tuyo y podrás revisarlo cuando lo necesites.'
  }, {
    q: '9️⃣ ¿Este material garantiza que voy a ingresar?',
    a: 'No. El ingreso depende de múltiples factores y del desempeño de cada aspirante. Este pack está diseñado como un material de apoyo para ayudarte a prepararte mejor.'
  }, {
    q: '🔟 ¿Puedo pedir devolución si no me convence?',
    a: 'Sí. Tu compra está protegida con una garantía de satisfacción de 7 días. Si dentro de ese período considerás que el material no es lo que esperabas, podés solicitar la devolución.'
  }];
  return <section className="py-5 px-4 sm:px-6 lg:px-8 bg-gray-900 border-t border-gray-800" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-4" data-id="element-63">
          Preguntas frecuentes
        </h2>

        <div className="space-y-1.5" data-id="element-64">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-lg overflow-hidden transition-all duration-300 ${isOpen ? 'border-green-500 bg-black' : 'border-gray-800 bg-gray-900'}`} data-id="element-65">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-4 py-2.5 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-66">
                  <span className={`text-sm md:text-base font-bold ${isOpen ? 'text-green-500' : 'text-white'}`} data-id="element-67">
                    {faq.q}
                  </span>
                  {isOpen ? <ChevronUpIcon className="w-5 h-5 text-green-500 flex-shrink-0 ml-3" data-id="element-68" /> : <ChevronDownIcon className="w-5 h-5 text-gray-400 flex-shrink-0 ml-3" data-id="element-69" />}
                </button>
                <AnimatePresence data-id="element-70">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-71">
                      <div className="px-4 pb-2 text-gray-300 text-sm leading-relaxed border-t border-gray-800/50 pt-2" data-id="element-72">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}